import { render, staticRenderFns } from "./activity-all-picture.vue?vue&type=template&id=39c4f00a&scoped=true&"
import script from "./activity-all-picture.vue?vue&type=script&lang=js&"
export * from "./activity-all-picture.vue?vue&type=script&lang=js&"
import style0 from "./activity-all-picture.vue?vue&type=style&index=0&id=39c4f00a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4f00a",
  null
  
)

export default component.exports